import { render, staticRenderFns } from "./LivingWill.vue?vue&type=template&id=823390be&scoped=true"
import script from "./LivingWill.vue?vue&type=script&lang=js"
export * from "./LivingWill.vue?vue&type=script&lang=js"
import style0 from "./LivingWill.vue?vue&type=style&index=0&id=823390be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823390be",
  null
  
)

export default component.exports